function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Chart as Chart$1, BarController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, BubbleController, ScatterController } from 'chart.js';
import { version, isProxy, toRaw, defineComponent, ref, shallowRef, onMounted, onUnmounted, watch, nextTick, h } from 'vue';
var CommonProps = {
  data: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  plugins: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  datasetIdKey: {
    type: String,
    "default": "label"
  },
  updateMode: {
    type: String,
    "default": undefined
  }
};
var A11yProps = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
};
var Props = _objectSpread(_objectSpread({
  type: {
    type: String,
    required: true
  },
  destroyDelay: {
    type: Number,
    "default": 0 // No delay by default
  }
}, CommonProps), A11yProps);
var compatProps = version[0] === "2" ? function (internals, props) {
  return Object.assign(internals, {
    attrs: props
  });
} : function (internals, props) {
  return Object.assign(internals, props);
};
function toRawIfProxy(obj) {
  return isProxy(obj) ? toRaw(obj) : obj;
}
function cloneProxy(obj) {
  var src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : obj;
  return isProxy(src) ? new Proxy(obj, {}) : obj;
}
function setOptions(chart, nextOptions) {
  var options = chart.options;
  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets, datasetIdKey) {
  var addedDatasets = [];
  currentData.datasets = nextDatasets.map(function (nextDataset) {
    // given the new set, find it's current match
    var currentDataset = currentData.datasets.find(function (dataset) {
      return dataset[datasetIdKey] === nextDataset[datasetIdKey];
    });
    // There is no original to update, so simply add new one
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return _objectSpread({}, nextDataset);
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data, datasetIdKey) {
  var nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getDatasetAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event, "dataset", {
    intersect: true
  }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getElementAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event, "nearest", {
    intersect: true
  }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */
function getElementsAtEvent(chart, event) {
  return chart.getElementsAtEventForMode(event, "index", {
    intersect: true
  }, false);
}
var Chart = defineComponent({
  props: Props,
  setup: function setup(props, param) {
    var expose = param.expose,
      slots = param.slots;
    var canvasRef = ref(null);
    var chartRef = shallowRef(null);
    expose({
      chart: chartRef
    });
    var renderChart = function renderChart() {
      if (!canvasRef.value) return;
      var type = props.type,
        data = props.data,
        options = props.options,
        plugins = props.plugins,
        datasetIdKey = props.datasetIdKey;
      var clonedData = cloneData(data, datasetIdKey);
      var proxiedData = cloneProxy(clonedData, data);
      chartRef.value = new Chart$1(canvasRef.value, {
        type: type,
        data: proxiedData,
        options: _objectSpread({}, options),
        plugins: plugins
      });
    };
    var destroyChart = function destroyChart() {
      var chart = toRaw(chartRef.value);
      if (chart) {
        if (props.destroyDelay > 0) {
          setTimeout(function () {
            chart.destroy();
            chartRef.value = null;
          }, props.destroyDelay);
        } else {
          chart.destroy();
          chartRef.value = null;
        }
      }
    };
    var update = function update(chart) {
      chart.update(props.updateMode);
    };
    onMounted(renderChart);
    onUnmounted(destroyChart);
    watch([function () {
      return props.options;
    }, function () {
      return props.data;
    }], function (param, param1) {
      var _param = _slicedToArray(param, 2),
        nextOptionsProxy = _param[0],
        nextDataProxy = _param[1],
        _param2 = _slicedToArray(param1, 2),
        prevOptionsProxy = _param2[0],
        prevDataProxy = _param2[1];
      var chart = toRaw(chartRef.value);
      if (!chart) {
        return;
      }
      var shouldUpdate = false;
      if (nextOptionsProxy) {
        var nextOptions = toRawIfProxy(nextOptionsProxy);
        var prevOptions = toRawIfProxy(prevOptionsProxy);
        if (nextOptions && nextOptions !== prevOptions) {
          setOptions(chart, nextOptions);
          shouldUpdate = true;
        }
      }
      if (nextDataProxy) {
        var nextLabels = toRawIfProxy(nextDataProxy.labels);
        var prevLabels = toRawIfProxy(prevDataProxy.labels);
        var nextDatasets = toRawIfProxy(nextDataProxy.datasets);
        var prevDatasets = toRawIfProxy(prevDataProxy.datasets);
        if (nextLabels !== prevLabels) {
          setLabels(chart.config.data, nextLabels);
          shouldUpdate = true;
        }
        if (nextDatasets && nextDatasets !== prevDatasets) {
          setDatasets(chart.config.data, nextDatasets, props.datasetIdKey);
          shouldUpdate = true;
        }
      }
      if (shouldUpdate) {
        nextTick(function () {
          update(chart);
        });
      }
    }, {
      deep: true
    });
    return function () {
      return h("canvas", {
        role: "img",
        ariaLabel: props.ariaLabel,
        ariaDescribedby: props.ariaDescribedby,
        ref: canvasRef
      }, [h("p", {}, [slots["default"] ? slots["default"]() : ""])]);
    };
  }
});
function createTypedChart(type, registerables) {
  Chart$1.register(registerables);
  return defineComponent({
    props: CommonProps,
    setup: function setup(props, param) {
      var expose = param.expose;
      var ref = shallowRef(null);
      var reforwardRef = function reforwardRef(chartRef) {
        ref.value = chartRef === null || chartRef === void 0 ? void 0 : chartRef.chart;
      };
      expose({
        chart: ref
      });
      return function () {
        return h(Chart, compatProps({
          ref: reforwardRef
        }, _objectSpread({
          type: type
        }, props)));
      };
    }
  });
}
var Bar = /* #__PURE__ */createTypedChart("bar", BarController);
var Doughnut = /* #__PURE__ */createTypedChart("doughnut", DoughnutController);
var Line = /* #__PURE__ */createTypedChart("line", LineController);
var Pie = /* #__PURE__ */createTypedChart("pie", PieController);
var PolarArea = /* #__PURE__ */createTypedChart("polarArea", PolarAreaController);
var Radar = /* #__PURE__ */createTypedChart("radar", RadarController);
var Bubble = /* #__PURE__ */createTypedChart("bubble", BubbleController);
var Scatter = /* #__PURE__ */createTypedChart("scatter", ScatterController);
export { Bar, Bubble, Chart, Doughnut, Line, Pie, PolarArea, Radar, Scatter, createTypedChart, getDatasetAtEvent, getElementAtEvent, getElementsAtEvent };